/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staging_BannerInputs */

const vi_staging_banner = /** @type {(inputs: Staging_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MÔI TRƯỜNG STAGING — dữ liệu chỉ để tập/test, KHÔNG phải dữ liệu thật`)
};

/**

* @param {Staging_BannerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const staging_banner = /** @type {((inputs?: Staging_BannerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staging_BannerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_staging_banner(inputs)
});